import(/* webpackMode: "eager", webpackExports: ["LegalNoticesProvider"] */ "/app/src/app/components/LegalNoticesProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/SiteFooter.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/tailwind.css");
